import React, { FC } from "react";
import Modal from "../../../../../shared/modal/modal";
import styles from "./save-confirmation-modal.module.scss";
import { firstSymbolsToUppercase } from "../../../../../utils/first-symbols-to-uppercase";
import confirmationIco from "../../../../../images/success.svg";
import Button from "../../../../ui-kit/button/button";
import { useTranslation } from "react-i18next";
import {
  InvestmentOpportunity,
  LandPlot,
  SpaceForRent,
} from "../../../../../interfaces/card";

interface SaveConfirmationModalProps {
  type: "InvestmentOpportunities" | "Plots" | "SpacesForRent";
  card: InvestmentOpportunity | LandPlot | SpaceForRent;
  onClose: () => void;
  text: string;
  onViewChanges: () => void;
}

const SaveConfirmationModal: FC<SaveConfirmationModalProps> = ({
  type,
  card,
  onClose,
  text,
  onViewChanges,
}) => {
  const { t } = useTranslation();
  return (
    <Modal onClose={onClose}>
      <div className={styles.confirmationModal}>
        <div className={styles.header}>
          <h2 className={styles.plotNumber}>
            {type === "Plots"
              ? firstSymbolsToUppercase(text)
              : type === "SpacesForRent"
                ? t("edit-attachments-modal.officeNumber", {
                    number: card.number,
                  })
                : ("description_a" in card &&
                    type === "InvestmentOpportunities" &&
                    card.description_a) ||
                  t("edit-attachments-modal.noData")}
          </h2>
        </div>
        <img
          src={confirmationIco}
          alt={t("edit-attachments-modal.confirmation.alt")}
        />
        <span className={styles.confirmText}>
          {t("edit-attachments-modal.confirmation.text")}
        </span>
        <Button className={styles.viewChanges} onClick={onViewChanges}>
          {t("edit-attachments-modal.buttons.viewChanges")}
        </Button>
      </div>
    </Modal>
  );
};

export default SaveConfirmationModal;
